import { render, staticRenderFns } from "./mWagerTypePopup.vue?vue&type=template&id=6e46a5ab&scoped=true"
import script from "./mWagerTypePopup.vue?vue&type=script&lang=js"
export * from "./mWagerTypePopup.vue?vue&type=script&lang=js"
import style0 from "./mWagerTypePopup.vue?vue&type=style&index=0&id=6e46a5ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e46a5ab",
  null
  
)

export default component.exports